import type { CompetitionStageDetailed, UpdateCompetitionStageRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateCompetitionStageDetails(
  competitionId: string,
  stageId: string,
  formData: UpdateCompetitionStageRequest
): Promise<CompetitionStageDetailed> {
  return requestApiJsonOrThrow<CompetitionStageDetailed>(
    `admin/competitions/${competitionId}/competition-stages/${stageId}`,
    {
      method: 'PATCH',
      body: formData,
    }
  )
}
